const transfer = () => {

  const t = {};
  const init = () => {

    bindUrlCopyAction();
    bindSnsBtnAction();
  }

  const scanShareString = () => {
    const target = document.querySelector('.mp-share-url__txt');
    if (target) {
      t.targetUrl = target.textContent;
    } else {
      t.targetUrl = 'URLの取得に失敗しました';
    }
  }

  const bindUrlCopyAction = () => {
    const copyBtn = document.querySelector('.mp-share-url__btn');
    if (!copyBtn) {
      return;
    }
    copyBtn.addEventListener('click', () => {
      scanShareString();
      copyAction();
    })
  }
  const copyAction = async () => {
    // navigator.clipboard は https でのみ動作
    await navigator.clipboard.writeText(t.targetUrl)
      .then(() => {
        t.copyResultStatus = true;
        t.copyResultTxt = 'クリップボードにコピーしました';
      })
      .catch(() => {
        t.copyResultStatus = false;
        t.copyResultTxt = 'クリップボードへのコピが失敗しました';
      })

    displayResultAction();
  }

  const displayResultAction = () => {
    const iconmodified = t.copyResultStatus
      ? '_valid'
      : '_invalid';
    const resultModal = document.createElement('div');
    resultModal.classList.add('c-modal', 'is-visibled');
    resultModal.innerHTML = `<div class="c-modal__inner"><p class="c-modal__interact"><span class="c-modal__interact-icon ${iconmodified}" aria-hidden="true"></span><span class="c-modal__interact-txt">${t.copyResultTxt}</span></p></div>`;
    document.body.appendChild(resultModal);

    setTimeout(() => {
      resultModal.remove();
    }, 2000)
  }

  const bindSnsBtnAction = () => {
    const btns = document.querySelectorAll('.mq-share-appli__btn');
    if (btns.length == 0) {
      return
    }
    const btnAction = BuildSnsBtnAction();

    btns.forEach(btn => {
      const specificSelector = [].filter.call(btn.classList, (c) => /^_/.test(c))[0];
      btn.addEventListener('click', () => {
        btnAction(specificSelector);
      })
    })
  }

  const BuildSnsBtnAction = () => {
    return (selector) => {
      const identify = /^_/.test(selector)
        ? selector.slice(1)
        : selector;

      const actions = {
        'line': () => {
          console.log('line action')
          window.open(`https://line.me/R/msg/text/?${t.targetUrl}`)
        },
        'mail': () => {
          console.log('mail action')
          location.href = `mailto:?body=${t.targetUrl}`
        }
      }

      scanShareString();
      actions[identify]();
    }
  }

  init();
}

export default transfer;
